<template>
  <div class="about">
    <!-- 引入3d模型 -->
    <iframe src="mms3D/index.html" id="iframe"></iframe>

    <div v-if="$store.state.pageshow">
      <header>
        <my-header></my-header>
      </header>
      <!-- 按右 -->
      <div
        :class="isshow_right ? 'my_right' : 'my_right_fixed'"
        @click="
          isright = !isright;
          isshow_right = !isshow_right;
          $store.commit('butfalse');
        "
      ></div>
      <!-- 按左 -->
      <div
        :class="isshow_left ? 'my_left' : 'my_left_fixed'"
        @click="
          isleft = !isleft;
          isshow_left = !isshow_left;
        "
      ></div>
      <center>
        <div :class="isleft ? 'left' : 'turnleft'">
          <!-- 总表实时信息 -->
          <message-all></message-all>
          <!-- 实时压力信息 -->
          <pressure-message></pressure-message>
          <!-- 实时流量信息 -->
          <flow-rate></flow-rate>
          <!-- 用水量信息 -->
          <use-water></use-water>
        </div>
        <div :class="isright ? 'right' : 'turnright'">
          <!-- 点位查询 -->
          <point-query></point-query>
          <!-- 管网统计 -->
          <pipe-network></pipe-network>
          <!-- 累计值统计 -->
          <cumulative-value></cumulative-value>
          <!-- 设备管理 -->
          <device-management></device-management>
        </div>
      </center>

      <!-- 左右下的动态gif -->
      <div class="gif_left"></div>
      <div class="gif_right"></div>
      <div class="gif_bottom"></div>

      <!-- 压力图 -->
      <pressure-but :class="isleft ? '' : 'press'"></pressure-but>

      <!-- 右边的按钮 -->
      <my-but :class="isright ? 'my_but' : 'my_but_turn'"></my-but>

      <!-- 左边按钮 -->
      <!-- <point-but></point-but> -->

      <!-- 弹框 -->
      <!-- <tan-kuang></tan-kuang> -->
      <div class="copyright">
        <span>软件平台研发单位：重庆木棉树软件开发有限公司 </span>
      </div>

      <!-- 告警弹框 -->
      <div class="alert-pop-up">
        <div id="alert">
          <ul v-for="item in alertdate" :key="item.water_device_name">
            <li>
              <div>{{item.water_device_name}}</div>
              <div class="quxiao" @click="caneralert(item.water_device_code)"></div>
            </li>
          </ul>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import MyHeader from "@/components/header/MyHeader.vue";
import MessageAll from "@/components/left/MessageAll.vue";
import PressureMessage from "@/components/left/PressureMessage.vue";
import FlowRate from "@/components/left/FlowRate.vue";
import UseWater from "@/components/left/UseWater.vue";
import PointQuery from "@/components/right/PointQuery.vue";
import PipeNetwork from "@/components/right/PipeNetwork.vue";
import CumulativeValue from "@/components/right/CumulativeValue.vue";
import DeviceManagement from "@/components/right/DeviceManagement.vue";
import MyBut from "@/components/com/MyBut.vue";
import PressureBut from "@/components/com/PressureBut.vue";
// import MySlider from '@/components/com/MySlider.vue'
// import PointBut from '@/components/com/PointBut.vue'
// import TanKuang from '@/components/com/TanKuang.vue'

export default {
  data() {
    return {
      isleft: false,  //这些状态都是一些控制页面的，功能已经开发完毕现在只剩下一个报警的功能，这些东西都不用看的
      isshow_left: false,
      isright: false,
      isshow_right: false,
      but_show: false,
      interv:null,
      alertdate:[]
    };
  },
  components: {
    MyHeader,
    MessageAll,
    PressureMessage,
    FlowRate,
    UseWater,
    CumulativeValue,
    PointQuery,
    PipeNetwork,
    DeviceManagement,
    MyBut,
    PressureBut,
    // MySlider
    // TanKuang,
    // PointBut
  },
  mounted(){
    //定时执行，如果后面做报警的功能，放开这里
    // this.interv = setInterval(()=>{
    //   if(this.$store.state.hours>=18&this.$store.state.hours<20){
    //     this.getalert();
    //   }
    // },61000)
  },
  beforeDestroy(){
    // clearInterval(this.interv)
  },
  methods: {
    //获取报警的数据并渲染
    getalert(){
      this.alertdate=[]
      console.log(this.$store.state.pressdata)
      this.$store.state.pressdata.forEach((item)=>{
        if(item.pma_value<0.35){
          document.getElementsByClassName('alert-pop-up')[0].style.display="block"  
          this.alertdate.push(item)
          
        }
      })
    },
    //取消报警按钮
    caneralert(code){
      this.alertdate.forEach((item,index)=>{
        if(item.water_device_code==code){
          this.alertdate.splice(index,1)
        }
      })
      if(this.alertdate.length==0){
        document.getElementsByClassName('alert-pop-up')[0].style.display="none"
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.about {
  background: #000634;
  width: 100vw;
  height: 100vh;
  /* cursor: pointer; */
}
#iframe {
  width: 100vw;
  height: 100vh;
  border: none;
  /* margin: 5vh 3vw 5vh 3vw; */
}
header {
  width: 98%;
  height: 5vh;
  text-align: center;
  border: .0625rem solid #808595;
  margin: .75rem 1.125rem 0 1.125rem;
  font-family: "pm";
  position: fixed;
  top: 0;
  left: 0;
  background: #000634;
  opacity: 0.9;
}
.left {
  margin-top: 0.9vh;
  width: 18.02%;
  /* border: .0625rem solid red; */
  height: 90.8vh;
  position: fixed;
  top: 6.5vh;
  left: 1.125rem;
  background: #000634;
  opacity: 0.9;
  transition: all 1s linear;
  transform: translateX(0);
}
.right {
  margin-top: 0.9vh;
  width: 18.02%;
  /* border: .0625rem solid red; */
  height: 90.8vh;
  position: fixed;
  top: 6.5vh;
  right: 1.125rem;
  background: #000634;
  opacity: 0.9;
  transition: all 1s linear;
  transform: translateX(0);
}
.gif_left {
  width: .9375rem;
  height: 100vh;
  background: url("@/assets/gif/左.gif") no-repeat center center;
  background-size: 100% 100%;
  position: fixed;
  left: 0;
  top: 0;
}
.gif_right {
  width: .9375rem;
  height: 100vh;
  background: url("@/assets/gif/右.gif") no-repeat center center;
  background-size: 100% 100%;
  position: fixed;
  right: 0;
  top: 0;
}
.gif_bottom {
  width: 100%;
  height: 2vh;
  background: url("@/assets/gif/下.gif") no-repeat center center;
  background-size: 100% 100%;
  position: fixed;
  left: 0;
  bottom: 0;
}
.my_left {
  background: url("@/assets/pengshui_right.png") no-repeat center center;
  background-size: 100% 100%;
  width: 2.875rem;
  height: 4.125rem;
  position: fixed;
  top: 50%;
  left: 17%;
  transition: all 1s linear;
  transform: translateX(100%);
  cursor: pointer;
}
.turnleft {
  margin-top: 0.9vh;
  width: 18.02%;
  height: 90.8vh;
  position: absolute;
  top: 6.5vh;
  margin-left: 1.125rem;
  background: #000634;
  opacity: 0.9;
  transition: all 1s linear;
  transform: translateX(-110%);
}

.my_left_fixed {
  background: url("@/assets/pengshui_right.png") no-repeat center center;
  background-size: 100% 100%;
  width: 2.875rem;
  height: 4.125rem;
  position: fixed;
  top: 50%;
  left: 3%;
  transition: all 1s linear;
  transform: translateX(-100%) rotateY(180deg);
  cursor: pointer;
}
/* .my_left_fixed:active{
  transform: rotateY(180deg);
} */

.my_right {
  background: url("@/assets/pengshui_left.png") no-repeat center center;
  background-size: 100% 100%;
  width: 2.875rem;
  height: 4.125rem;
  position: fixed;
  top: 50%;
  right: 21.5%;
  transition: all 1s linear;
  transform: translateX(100%);
  cursor: pointer;
}
.turnright {
  margin-top: 0.9vh;
  width: 18.02%;
  /* border: .0625rem solid red; */
  height: 90.8vh;
  position: absolute;
  top: 6.5vh;
  right: 1.125rem;
  background: #000634;
  opacity: 0.9;
  transition: all 1s linear;
  transform: translateX(110%);
}
.my_right_fixed {
  background: url("@/assets/pengshui_left.png") no-repeat center center;
  background-size: 100% 100%;
  width: 2.875rem;
  height: 4.125rem;
  position: fixed;
  top: 50%;
  right: 3%;
  transition: all 1s linear;
  transform: translateX(100%) rotateY(-180deg);
  cursor: pointer;
}

.my_but {
  width: 3.38vw;
  height: 15.09vh;
  position: fixed;
  top: 8%;
  right: 0;
  transition: all 1s linear;
  transform: translateX(-100%);
}
.my_but_turn {
  width: 3.38vw;
  height: 15.09vh;
  position: fixed;
  top: 8%;
  right: 0;
  transition: all 1.5s linear;
  transform: translateX(100%);
}

.press {
  display: none;
  transition: all 1s linear;
  /* transform: translateX(-200%); */
}
.copyright {
  width: 100%;
  height: 2vh;
  font-size: 1rem;
  position: fixed;
  bottom: 1vh;
  left: 0;
  text-align: center;
  color: #ffffff;
  opacity: 0.8;

}
.copyright span {
  margin-left: 2vw;
	-o-user-select: none;
	-moz-user-select: none; /*/火狐 firefox/*/
	-webkit-user-select: none; /*/webkit浏览器/*/
	-ms-user-select: none; /*/IE10+/*/
	-khtml-user-select: none; 
	user-select: none;
 
}
.alert-pop-up{
  width: 10%;
  height: 20%;
  position: fixed;
  left: 50%;
  top: 40%;
  // border: .0625rem solid gray;
  transform: translateX(-50%) translateY(-50%);
  display: none;
  text-align: center;
  color: white;
  font-size: 16px;
  // background: #cccccc;
  // opacity: 0.9;
  #alert{
    ul{
      // margin-top: 15px;
      display: flex;
      flex-direction: column;
      align-items: center;
      li{
        width: 70%;
        height: 50px;
        background: url("@/assets/alert.png") no-repeat center center;
        background-size: 100% 100%;
        line-height: 50px;
        font-size: 13px;
        margin-top: 5px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-left: 100px;
        padding-right: 10px;
        .quxiao{
          // position: relative;
          // right: 0;
          // top: 0;
          width: 20px;
          height: 20px;
          // font-size: 15px;
          color: white;
          cursor: pointer;
          background: url("@/assets/quxiao_alert.png") no-repeat center center;
          background-size: 100% 100%;
        }
      }
          
    }
  }

}
</style>
